import appConfig from "@core/config";
import { CourseItemDto } from "@core/typesV2/courseItem";
import { NavigateFunction } from "react-router-dom";

import AxiosService, { TokenHandlers } from "./axiosServiceV2";

function propagateHasSubmittedAcrossLevels(items: CourseItemDto[]) {
  let previousSubmitted = false;

  function walk(nodes: CourseItemDto[]): CourseItemDto[] {
    return nodes.map((node) => {
      const updatedNode = { ...node };

      if (
        updatedNode.hasActivities === false &&
        updatedNode.hasSubmitted === false &&
        previousSubmitted === true
      ) {
        updatedNode.hasSubmitted = true;
        updatedNode.availableToStart = false;
      }

      // Update previousSubmitted AFTER processing current node
      previousSubmitted = updatedNode.hasSubmitted === true;

      if (Array.isArray(updatedNode.items) && updatedNode.items.length > 0) {
        updatedNode.items = walk(updatedNode.items);
      }

      return updatedNode;
    });
  }

  return walk(items);
}

export default class CourseItemService extends AxiosService {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super(
      `${appConfig.LEARNING_BASE_URL}/api/v1/courses`,
      tokenHandlers,
      navigateTo,
    );
  }

  async getOutline(courseId: string) {
    const result = await this.get<CourseItemDto[]>(`${courseId}/outline`);

    return propagateHasSubmittedAcrossLevels(result);
  }
}
